<div class="as" role="group" aria-label="Reparto de los puntos por área">
  <div class="as-row" *ngFor="let r of rows; trackBy: trackArea" [style.--area]="r.color">
    <label class="as-name" [for]="uid + '-' + r.area"><i [class]="r.icon" aria-hidden="true"></i> {{ r.label }}</label>
    <input
      class="as-input"
      type="number"
      inputmode="numeric"
      min="0"
      [max]="points ?? 0"
      step="1"
      [id]="uid + '-' + r.area"
      [value]="r.value"
      [attr.aria-invalid]="diff !== 0"
      [attr.aria-describedby]="uid + '-sum'"
      (input)="setValue(r.area, $any($event.target).value)"
      [attr.aria-label]="'Puntos de ' + r.label"
    />
    <span class="as-bar" aria-hidden="true"><span class="as-fill" [style.width.%]="r.pct"></span></span>
  </div>

  <p class="as-sum" [id]="uid + '-sum'" [class.ok]="diff === 0" [class.off]="diff !== 0" aria-live="polite">
    <ng-container *ngIf="diff === 0"
      ><i class="fa-solid fa-circle-check" aria-hidden="true"></i> {{ sum }} de {{ points }} pts</ng-container
    >
    <ng-container *ngIf="diff > 0"
      ><i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i> Faltan {{ diff }} de {{ points }} pts</ng-container
    >
    <ng-container *ngIf="diff < 0"
      ><i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i> Sobran {{ -diff }} de {{ points }} pts</ng-container
    >
  </p>
</div>
